<template>
	<a @click="pickFile">
		<template v-if="useSlot">
			<slot></slot>
		</template>
		<template v-else>
			<v-btn color="primary" :disabled="loading" :loading="loading"><v-icon class="mr-2">add_photo_alternate</v-icon> {{ label }}</v-btn>
		</template>
		<input
			:key="fileInputId"
			type="file"
			style="display: none"
			ref="image"
			accept="image/*"
			@change="filesChange"
		>
	</a>	
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	export default {
		props: {
			value: {
				type: String,
				default: ''
			},
			label: {
				type: String,
				default: 'Image Upload'
			},
			ratio: {
				type: Number,
				default: (1200/630)
			},
			useSlot: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				fileInputId: Math.floor(Math.random()*16777215).toString(16),
				loading: false,
				selectedFile: null,
				uploadedImage: {
					fileName: '',
					url: '',
				},
				maxImageSize: {
					width: 2048,
					height: 2048
				}
		    }
		},
	    methods: {
			getOrientation (file, callback) 
			{
				var reader = new FileReader();
				reader.onload = function(e) {

					var view = new DataView(e.target.result);
					if (view.getUint16(0, false) != 0xFFD8) return callback(-2);
					var length = view.byteLength;
					var offset = 2;
					while (offset < length) {
						var marker = view.getUint16(offset, false);
						offset += 2;
						if (marker == 0xFFE1) {
							var little = view.getUint16(offset += 8, false) == 0x4949;
							offset += view.getUint32(offset + 4, little);
							var tags = view.getUint16(offset, little);
							offset += 2;
							for (var i = 0; i < tags; i++)
								if (view.getUint16(offset + (i * 12), little) == 0x0112)
									return callback(view.getUint16(offset + (i * 12) + 8, little));
						}
						else if ((marker & 0xFF00) != 0xFF00) break;
						else offset += view.getUint16(offset, false);
					}
					return callback(0); // +- edit
				};
				reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
			}, 
			resetOrientation (srcBase64, srcOrientation, callback) 
			{
				var img = new Image()
				var maxImageSize = this.maxImageSize
				var mime_type = null
				
				var mime = srcBase64.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
				if (mime && mime.length) {
					mime_type = mime[1]
				}

				img.onload = function() {
					var width = img.width,
						height = img.height,
						canvas = document.createElement('canvas'),
						ctx = canvas.getContext("2d");

					// resize image
					if (width > height) {
						if (width > maxImageSize.width) {
							height *= maxImageSize.width / width
							width = maxImageSize.width
						}
					} else {
						if (height > maxImageSize.height) {
							width *= maxImageSize.height / height
							height = maxImageSize.height
						}
					}

					// set proper canvas dimensions before transform & export
					if (4 < srcOrientation && srcOrientation < 9) {
						canvas.width = height;
						canvas.height = width;
					} else {
						canvas.width = width;
						canvas.height = height;
					}

					// transform context before drawing image
					switch (srcOrientation) {
						case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
						case 3: ctx.transform(-1, 0, 0, -1, width, height ); break;
						case 4: ctx.transform(1, 0, 0, -1, 0, height ); break;
						case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
						case 6: ctx.transform(0, 1, -1, 0, height , 0); break;
						case 7: ctx.transform(0, -1, -1, 0, height , width); break;
						case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
						default: break;
					}

					// draw image
					ctx.drawImage(img, 0, 0, width, height);

					// export base64
					// callback(canvas.toDataURL());
					callback(canvas.toDataURL(mime_type, 90));
				};

				img.src = srcBase64;
			},
			imageValidator (fileList) 
			{
				return new 
					Promise((resolve) => {
						const reader = new FileReader()
						reader.onload = (e) => {
							const img = new Image()
							img.onload = () => {
								resolve(true)
							}
							img.src = reader.result
						}
						reader.readAsDataURL(fileList[0])
					})				
			},
			filesChange (event) 
			{
				var fieldName = event.target.name
				var fileList = event.target.files

				if (!fileList.length) return

				this.imageValidator(fileList).then((result) => {
					this.loading = true

					if (result) {
						var imageObj = {
							file: fileList[0],
							fileName: fileList[0].name,
							dataSrc: '',
							caption: '',
							imageVersion: 1,
							watermarkPosition: 9,
							watermarkOpacity: 60
						}

						var createImage = (file, orientation) => {
							this.createImage(fileList[0], orientation)
							.then((dataSrc) => {
								imageObj.dataSrc = dataSrc
								this.selectedFile = imageObj
								this.submitImageToServer(imageObj)
							})
						}

						this.getOrientation(fileList[0], function (ori) { // 1. get exif
							// this.reader(fileList[x], ori ? ori : 1)
							createImage(fileList[0], ori ? ori : 1)
						})
					} else {
						this.loading = false
					}
				})

			},
			createImage (file, orientation) 
			{
				var self = this
				return new Promise((resolve, reject) => {
					var reader = new FileReader()

					reader.onload = (e) => {
	  					var callback = function (base64data) {
							resolve(base64data)
						}
						var base64data = e.target.result
						var filetype = base64data.substring("data:image/".length, base64data.indexOf(";base64"))

						if (filetype != 'gif') {
							self.resetOrientation(base64data, orientation, callback)
						} else {
							resolve(base64data)
						}
						// resolve(e.target.result)
						// this.loading = false
					}
					reader.readAsDataURL(file)
				})
			},
	        pickFile () {
	            this.$refs.image.click ()
	        },			
			async submitImageToServer (image) {
				let apiUrl = `${config.BASE_URL}/image/base64`;
				let formData = new FormData()

				let coverBase64 = image.dataSrc

				formData.append('image', coverBase64)
				formData.append('position', 0)
				formData.append('rotation', 0)

				await axios.post(apiUrl, formData)
					.then(response => { 
						this.uploadedImage.fileName = response.data.data.imageFileName
						this.uploadedImage.url = response.data.data.imagePath

						this.$emit('upload-success', response.data.data)
						this.$emit('input', response.data.data.imagePath)

						this.$refs.image.value = ""

						this.loading = false
					})
					.catch( (error) => {
						this.$store.commit(types.SET_ERROR_MSG, error)
					})
			}
	    },
	    mounted () {
	    	this.$nextTick(() => {
		    	this.uploadedImage.url = this.value
	    	})
	    },
	    watch: {
	    	value (val) {
	    		if (val != this.uploadedImage.url) {
	    			this.uploadedImage.url = this.value
	    		}
	    	}
	    }
	}
</script>

<style scoped lang="scss">
	.img-preview,
	.empty-image-box {
		margin: 6px 8px;
		cursor: pointer;
	}
	.img-preview {
		&:hover {
			opacity: .75;
		}
	}
	.empty-image-box {
		background: #F5F5F5;
		height: 210px;
		width: 400px;

		display: flex;
		flex-flow: columns;
		justify-content: center;
		align-items: center;

		h4 {
			color: #757575;
			text-transform: uppercase;
		}
	}
</style>
